<script setup lang="ts">
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import ProfileMenu from "@/components/ui/ProfileMenu.vue";
import { ref } from "vue";
import { gql } from "@apollo/client/core";
import { useQuery, useResult } from "@vue/apollo-composable";
import { formatCurrency } from "@/libs/filters";
import { useAuthStore } from "@/stores/auth";
import UserArea from "../../components/ui/UserArea.vue";

const displayModeMobile = ref(false);
const authStore = useAuthStore();
</script>

<template>
  <DefaultLayout>
    <article class="container framework-slot">
      <UserArea title="Histórico de Pagamento">
        <table class="billingTable">
          <thead class="billingThead">
            <tr>
              <th scope="col">N° #</th>
              <th scope="col">Data</th>
              <th scope="col">Item</th>
              <th scope="col">Detalhes</th>
            </tr>
          </thead>
          <tbody class="billingTbody">
            <tr>
              <th scope="row">1</th>
              <td>01/05/2022</td>
              <td>Parcela do Plano Anual</td>
              <td>
                R$ 600,00 <br />
                <span class="paymentMethod">Mastercard</span>
              </td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>01/04/2022</td>
              <td>Parcela do Plano Anual</td>
              <td>
                R$ 600,00 <br />
                <span class="paymentMethod">Mastercard</span>
              </td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>01/03/2022</td>
              <td>Parcela do Plano Anual</td>
              <td>
                R$ 600,00 <br />
                <span class="paymentMethod">Mastercard</span>
              </td>
            </tr>
            <tr>
              <th scope="row">4</th>
              <td>01/02/2022</td>
              <td>Parcela do Plano Anual</td>
              <td>
                R$ 600,00 <br />
                <span class="paymentMethod">Mastercard</span>
              </td>
            </tr>
            <tr>
              <th scope="row">5</th>
              <td>01/01/2022</td>
              <td>Parcela do Plano Anual</td>
              <td>
                R$ 600,00 <br />
                <span class="paymentMethod">Mastercard</span>
              </td>
            </tr>
          </tbody>
        </table>
      </UserArea>
    </article>
  </DefaultLayout>
</template>

<style scoped>
h5 {
  margin-top: 20px;
  font-weight: 600;
  color: var(--primary-color);
}

.profile {
  background-color: var(--dark-color);
  color: var(--white-ice);
  border-radius: 0.5rem;
  padding: 10px;
  margin-bottom: 10px;
}

.profile h5 {
  font-size: 14px;
  font-weight: 500;
  margin: 0 auto;
}
/* 
.profile ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
}

.profile ul li {
  border-right: 2px solid var(--dark-grey);
}

.profile ul li:last-child {
  width: 100%;
  border: none;
} */

.profileContent {
  padding: 5px 10px 5px 25px;
}

.profileContent h5 {
  margin-bottom: 15px;
}

.profileContentNav {
  border: 1px solid var(--dark-grey);
  border-radius: 0.25rem;
  padding: 5px 15px;
  margin-bottom: 10px;
  display: block;
}

.profileContentNav:last-child {
  margin-bottom: 0 auto;
}

.profileContentNav .form-control {
  background-color: var(--dark-color);
  color: var(--white-ice);
  border-color: var(--dark-grey);
}

.profileContentNav .billingTable {
  width: 100%;
  text-align: center;
}

.profileContentNav .billingThead tr {
  border-bottom: 2px solid var(--dark-grey);
}

.profileContentNav .billingTbody tr {
  border-bottom: 1px solid var(--dark-grey);
  vertical-align: top;
}

.profileContentNav .billingTbody tr:last-child {
  border: none;
}

.profileContentNav .paymentMethod {
  color: var(--primary-color);
  font-size: 11px;
  font-style: italic;
}

.btn {
  width: 200px;
  margin-bottom: 10px;
}

.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--dark-color);
}

.footer {
  margin: 0 auto;
}

@media (max-width: 767.98px) {
  /* .profile ul {
    flex-direction: column;
  }

  .profile ul li {
    border: none;
    border-bottom: 1px solid var(--dark-grey);
  } */

  .profileContentNav .billingTable {
    font-size: 12px;
  }

  .profileContent {
    padding: 15px;
  }
}

@media (max-width: 575.98px) {
  .profileContentNav .billingTable td {
    border-left: 1px solid var(--dark-grey);
  }
}
</style>
